'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/*
*  Copyright (C) 1998-2017 by Northwoods Software Corporation. All Rights Reserved.
*/
import * as go from '../../../../libs/gojs/release/go';
import { DiagramConsts } from '../diagram-consts';
// The SectorReshapingTool shows three handles:
// two for changing the angles of the sides of the filled sector,
// and one for controlling the diameter of the sector.
// This depends on there being three data properties, "angle", "sweep", and "radius",
// that hold the needed information to be able to reproduce the sector.
/**
* This SectorReshapingTool class allows for the user to interactively modify the angles of a "pie"-shaped sector of a circle.
* When a node is selected, this shows two handles for changing the angles of the sides of the sector and one handle for changing the radius.
* @constructor
* @extends Tool
* @class
*/
var RingGraphReshapingTool = /** @class */ (function (_super) {
    __extends(RingGraphReshapingTool, _super);
    function RingGraphReshapingTool() {
        var _this = _super.call(this) || this;
        _this.name = 'RingReshaping';
        _this._handle = null;
        // these are the names of the data properties to read and write
        _this.radiusProperty = 'radius';
        _this.startAngleProperty = 'startAngle';
        _this.endAngleProperty = 'endAngle';
        _this.sweepProperty = 'sweep';
        return _this;
    }
    /**
    * This tool can only start if Diagram.allowReshape is true and the mouse-down event
    * is at a tool handle created by this tool.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.canStart = function () {
        if (!this.isEnabled) {
            return false;
        }
        var diagram = this.diagram;
        if (diagram === null || diagram.isReadOnly) {
            return false;
        }
        if (!diagram.allowReshape) {
            return false;
        }
        var h = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        return (h !== null);
    };
    /**
    * If the Part is selected, show two angle-changing tool handles and one radius-changing tool handle.
    * @override
    * @this {SectorReshapingTool}
    * @param {Part} part
    */
    RingGraphReshapingTool.prototype.updateAdornments = function (part) {
        if (part.category !== DiagramConsts.elements.ringGraphKey) {
            return;
        }
        var data = part.data;
        if (part.isSelected && data !== null && this.diagram !== null && !this.diagram.isReadOnly) {
            var ad = part.findAdornment(this.name);
            if (ad === null) {
                var $ = go.GraphObject.make;
                ad =
                    $(go.Adornment, 'Spot', $(go.Placeholder), $(go.Shape, 'Diamond', { name: 'RADIUS', fill: 'lime', width: 10, height: 10, cursor: 'move' }, new go.Binding('name', '', function (d) { return d.locked ? 'DisabledRADIUS' : 'RADIUS'; }), new go.Binding('fill', '', function (d) { return d.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (d) { return d.locked ? '' : 'move'; }), new go.Binding('alignment', '', function (d) {
                        var angle = RingGraphReshapingTool.prototype.getAngle(d);
                        var sweep = RingGraphReshapingTool.prototype.getSweep(d);
                        var scale = d.radiusPercentage;
                        var p = new go.Point(0.5 * (scale / 100.0), 0).rotate(angle + sweep / 2);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })), $(go.Shape, 'Circle', { name: 'ANGLE', fill: 'lime', width: 8, height: 8, cursor: 'move' }, new go.Binding('name', '', function (d) { return d.locked ? 'DisabledANGLE' : 'ANGLE'; }), new go.Binding('fill', '', function (d) { return d.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (d) { return d.locked ? '' : 'move'; }), new go.Binding('alignment', '', function (d) {
                        var angle = RingGraphReshapingTool.prototype.getAngle(d);
                        var p = new go.Point(0.5, 0).rotate(angle);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })), $(go.Shape, 'Circle', { name: 'END_ANGLE', fill: 'lime', width: 8, height: 8, cursor: 'move' }, new go.Binding('name', '', function (d) { return d.locked ? 'DisabledANGLE' : 'END_ANGLE'; }), new go.Binding('fill', '', function (d) { return d.locked ? '#f65177' : 'lime'; }), new go.Binding('cursor', '', function (d) { return d.locked ? '' : 'move'; }), new go.Binding('visible', 'isFullRing', function (isFullRing) { return !isFullRing; }), new go.Binding('alignment', '', function (d) {
                        var angle = RingGraphReshapingTool.prototype.getAngle(d);
                        var sweep = RingGraphReshapingTool.prototype.getSweep(d);
                        var p = new go.Point(0.5, 0).rotate(angle + sweep);
                        return new go.Spot(0.5 + p.x, 0.5 + p.y);
                    })));
                ad.adornedObject = part.locationObject;
                part.addAdornment(this.name, ad);
            }
        }
        else {
            part.removeAdornment(this.name);
        }
    };
    /**
    * Remember the original angles and radius and start a transaction.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.doActivate = function () {
        var diagram = this.diagram;
        if (diagram === null) {
            return;
        }
        this._handle = this.findToolHandleAt(diagram.firstInput.documentPoint, this.name);
        if (this._handle === null) {
            return;
        }
        var part = this._handle.part.adornedPart;
        if (part === null || part.data === null) {
            return;
        }
        this.startTransaction(this.name);
        this.isActive = true;
    };
    /**
    * Stop the transaction.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.doDeactivate = function () {
        this.stopTransaction();
        this._handle = null;
        this.isActive = false;
    };
    /**
    * Restore the original angles and radius and then stop this tool.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.doCancel = function () {
        this.stopTool();
    };
    /**
    * Depending on the current handle being dragged, update the "radius", the "angle", or the "sweep"
    * properties on the model data.
    * Those property names are currently parameterized as static members of SectorReshapingTool.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.doMouseMove = function () {
        var diagram = this.diagram;
        if (this.isActive && diagram !== null) {
            var h = this._handle;
            var center = h.part.adornedObject.getDocumentPoint(go.Spot.Center);
            var node = h.part.adornedPart;
            var mouse = diagram.lastInput.documentPoint;
            if (h.name === 'RADIUS') {
                var dst = Math.sqrt(center.distanceSquaredPoint(mouse));
                var radius = RingGraphReshapingTool.prototype.getRadius(node.data);
                var percent = dst < radius ? (dst / radius) * 100 : 99;
                diagram.model.setDataProperty(node.data, 'radiusPercentage', Math.round(percent));
            }
            else if (h.name === 'ANGLE') {
                var dir = center.directionPoint(mouse);
                var sweep = RingGraphReshapingTool.prototype.getSweep(node.data);
                var endAngle = (dir + sweep + 360) % 360;
                diagram.model.setDataProperty(node.data, this.startAngleProperty, Math.round(dir));
                diagram.model.setDataProperty(node.data, this.endAngleProperty, Math.round(endAngle));
            }
            else if (h.name === 'END_ANGLE') {
                var dir = center.directionPoint(mouse);
                diagram.model.setDataProperty(node.data, this.endAngleProperty, Math.round(dir));
            }
        }
    };
    /**
    * Finish the transaction and stop the tool.
    * @override
    * @this {SectorReshapingTool}
    */
    RingGraphReshapingTool.prototype.doMouseUp = function () {
        var diagram = this.diagram;
        if (this.isActive && diagram !== null) {
            this.transactionResult = this.name; // successful finish
        }
        this.stopTool();
    };
    // static functions for getting data
    RingGraphReshapingTool.prototype.getRadius = function (data) {
        var size = go.Size.parse(data.size);
        return size.width / 2.0;
    };
    RingGraphReshapingTool.prototype.getAngle = function (data) {
        var angle = data.startAngle;
        if (!(typeof angle === 'number') || isNaN(angle)) {
            angle = 0;
        }
        else {
            angle = angle % 360;
        }
        return angle;
    };
    RingGraphReshapingTool.prototype.getSweep = function (data) {
        return (data.endAngle - data.startAngle + 360) % 360;
    };
    return RingGraphReshapingTool;
}(go.Tool));
export { RingGraphReshapingTool };
